"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_bracelet__remove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "48c5a24d-036d-4169-800c-6fbdf658911b",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "53fa1425-67a3-43b2-a672-dbf8cbb0ca16",
    x1: 85.51,
    y1: 110.17,
    x2: 137.67,
    y2: 162.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "bracelet-remove-hi"), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,176H71.53a8.26,8.26,0,0,1-8.14-6.38L56.05,137.5a2.3,2.3,0,0,1,0-.45V55a2.3,2.3,0,0,1,0-.45l7.34-32.12A8.26,8.26,0,0,1,71.53,16h49.86a8.3,8.3,0,0,1,8.18,6.59l6.39,32a1.81,1.81,0,0,1,0,.4v82.1a2.3,2.3,0,0,1-.05.45l-7.34,32.12A8.25,8.25,0,0,1,120.48,176Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.61,167.62a8.25,8.25,0,0,1-8.13,6.38H71.53a8.26,8.26,0,0,1-8.14-6.38L56.05,135.5a2.3,2.3,0,0,1,0-.45v2a2.3,2.3,0,0,0,0,.45l7.34,32.12A8.26,8.26,0,0,0,71.53,176h49a8.25,8.25,0,0,0,8.13-6.38L136,137.5a2.3,2.3,0,0,0,.05-.45v-2a2.3,2.3,0,0,1-.05.45Z",
    transform: "translate(0 0)",
    fill: "#1d1d1b",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,140H64a8,8,0,0,1-8-8V60a8,8,0,0,1,8-8h64a8,8,0,0,1,8,8v72A8,8,0,0,1,128,140Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,138H64a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8v-2A8,8,0,0,1,128,138Z",
    transform: "translate(0 0)",
    fill: "#1d1d1b",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.03,
    y: 38,
    width: 60,
    height: 4,
    rx: 1.94,
    ry: 1.94,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.03,
    y: 30,
    width: 58,
    height: 4,
    rx: 1.9,
    ry: 1.9,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.03,
    y: 22,
    width: 56,
    height: 4,
    rx: 1.87,
    ry: 1.87,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 150,
    width: 60,
    height: 4,
    rx: 1.94,
    ry: 1.94,
    transform: "translate(192 304) rotate(180)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 158,
    width: 58,
    height: 4,
    rx: 1.9,
    ry: 1.9,
    transform: "translate(192 320) rotate(-180)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 166,
    width: 56,
    height: 4,
    rx: 1.87,
    ry: 1.87,
    transform: "translate(192 336) rotate(180)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.03,
    y1: 82,
    x2: 82.03,
    y2: 110,
    fill: "none",
    stroke: "#f4f4f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.03,
    y1: 110,
    x2: 82.03,
    y2: 82,
    fill: "none",
    stroke: "#f4f4f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,106v26a8,8,0,0,1-8,8H64a8,8,0,0,1-5.79-2.47C56.85,136.09,96.68,176,96.68,176h23.8a8.25,8.25,0,0,0,8.13-6.38L136,137.5a2.3,2.3,0,0,0,.05-.45V106Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#53fa1425-67a3-43b2-a672-dbf8cbb0ca16)"
  }));
}

var _default = ic_bracelet__remove;
exports.default = _default;